<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="container-fluid">
    <div class="job-details-wrapper" *ngIf="jobDetails as job">
      <div class="left-column">
        <div class="job-main">
          <div class="company-section">
            <button class="back-nav-btn" (click)="goBack()" title="Go Back">
              <i class="bi bi-arrow-left"></i>
            </button>
            <div class="company-logo">
              <img *ngIf="job.company_logo" [src]="job.company_logo" [alt]="job.company_name" class="company-logo-img">
              <i *ngIf="!job.company_logo" class="bi bi-robot"></i>
            </div>

            <div>
              <ng-container *ngIf="job.company_name">
                <p class="company-name">{{ job.company_name }}</p>
              </ng-container>

              <ng-container *ngIf="job.job_title">
                <h1>{{ job.job_title }}</h1>
              </ng-container>

              <div class="job-badges">
                <ng-container *ngIf="job.job_type">
                  <span>{{ job.job_type }}</span>
                </ng-container>

                <ng-container *ngIf="job.work_mode">
                  <span class="active">{{ job.work_mode }}</span>
                </ng-container>

                <ng-container *ngIf="job.locations.length">
                  <span *ngFor="let location of job.locations">
                    <i class="bi bi-geo-alt"></i> {{ location }}
                  </span>
                </ng-container>
              </div>

              <div class="job-meta">
                <ng-container *ngIf="job.application_deadline">
                  <div>
                    <i class="bi bi-calendar"></i>Deadline :
                    {{ job.application_deadline | date: "dd MMM yyyy" }}
                  </div>
                </ng-container>

                <ng-container *ngIf="job.number_of_openings">
                  <div>
                    <i class="bi bi-people"></i>
                    {{ job.number_of_openings }}
                    openings
                  </div>
                </ng-container>
              </div>

              <ng-container *ngIf="job.preferred_skills.length">
                <div class="skills">
                  <span *ngFor="let skill of job.preferred_skills">{{
                    skill
                    }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- <div class="content-card">
          <ng-container *ngIf="job.job_title">
            <h2>About {{ job.job_title }}</h2>
          </ng-container>
          <p>{{ job.description }}</p>
        </div> -->

        <div class="content-card">
          <ng-container *ngIf="job.description">
            <h2>Job description</h2>
            <p class="description">{{ job.description }}</p>
          </ng-container>

          <ng-container *ngIf="job.roles_and_responsibilities">
            <h4>Roles & responsibilities</h4>
            <ul>
              <li *ngFor="let role of rolesAndResponsibilities">{{ role }}</li>
            </ul>
          </ng-container>

          <ng-container *ngIf="job.required_skills.length">
            <h4>Required skills</h4>
            <div class="skills">
              <span *ngFor="let roles of job.required_skills">
                {{ roles }}</span>
            </div>
          </ng-container>

          <ng-container *ngIf="job.preferred_skills.length">
            <h4>Preferred skills</h4>
            <div class="skills">
              <span *ngFor="let roles of job.preferred_skills">
                {{ roles }}</span>
            </div>
          </ng-container>
        </div>

        <div class="content-card">
          <h2>Eligibility</h2>
          <div class="eligibility-grid">
            <ng-container *ngIf="job.education.length">
              <div class="eligibility-item">
                <p class="label">Education</p>

                <div class="skills">
                  <span *ngFor="let education of job.education">
                    {{ education }}</span>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="job.min_cgpa">
              <div class="eligibility-item">
                <p class="label">Minimum CGPA</p>
                <h4>{{ job.min_cgpa }}</h4>
              </div>
            </ng-container>

            <ng-container *ngIf="job.year_of_passing.length">
              <div class="eligibility-item">
                <p class="label">Year of passing</p>
                <h4 *ngFor="let year of job.year_of_passing">{{ year }}</h4>
              </div>
            </ng-container>

            <ng-container *ngIf="job.experience_level">
              <div class="eligibility-item">
                <p class="label">Experience</p>
                <h4>{{ job.experience_level }}</h4>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="content-card mb-5">
          <h2>Compensation & perks</h2>

          <ng-container *ngIf="job.salary_min">
            <div class="compensation-content">
              <div class="compensation-block">
                <h4>
                  Salary / stipend :
                  <span>
                    {{ formatSalary(job.salary_min, job.salary_max, job.currency, job.payment_frequency) }}
                  </span>
                </h4>
              </div>

              <div class="compensation-block" *ngIf="job.expected_full_time_salary">
                <h4>
                  Expected Full-time CTC:
                  <span> {{ formatSalary(job.expected_full_time_salary, job.expected_full_time_salary, job.expected_full_time_salary_currency || job.currency, job.expected_full_time_salary_frequency || job.payment_frequency) }} </span>
                </h4>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="job.perks_and_benefits.length">
            <div class="perk-tags">
              <span *ngFor="let perks of job.perks_and_benefits">{{
                perks
                }}</span>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="right-column">
        <div class="job-side-card">
          <p class="company-name">{{ job.company_name }}</p>

          <h3>{{ job.job_title }}</h3>

          <ng-container *ngIf="job.salary_min">
            <div class="salary">
              {{ formatSalary(job.salary_min, job.salary_max, job.currency, job.payment_frequency) }}
            </div>
          </ng-container>

          <ng-container *ngIf="job.has_applied; else showMessage">
            <div class="applied-status">
              <i class="bi bi-check-circle-fill"></i>
              <span>Successfully Applied</span>
            </div>
          </ng-container>
          <ng-template #showMessage>
            <button class="apply-btn mt-2" (click)="goToApplyPage(job.job_id)">
              Apply now
            </button>
          </ng-template>

          <button class="save-btn" (click)="toggleSaveJob()" [disabled]="isJobSave || isJobRemove">
            <i class="bi" [ngClass]="
                jobDetails.is_saved ? 'bi-bookmark-fill' : 'bi-bookmark'
              "></i>
            {{
            isJobSave
            ? "Saving..."
            : isJobRemove
            ? "Removing..."
            : jobDetails.is_saved
            ? "Saved"
            : "Save Job"
            }}
          </button>
        </div>

        <div class="process-card">
          <div class="process-header">
            <i class="bi bi-stars"></i>
            <h3>AI Hiring Process</h3>
          </div>

          <p>
            This role follows an AI-powered hiring process to ensure a fair, secure, and objective evaluation. Our
            recruiters will review your overall performance and shortlist eligible candidates for the final selection.
          </p>

          <div class="process-step" *ngFor="let step of jobDetails.hiring_process; let i = index">
            <strong>Stage {{ i + 1 }}:</strong>
            {{step}}
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>